<template>
  <el-dialog :visible.sync="show" :fullscreen="true" :show-close="false" custom-class="dfcd" append-to-body>
    <div slot="title">
      表单配置<span v-if="dynamicFormId">&nbsp;:&nbsp;{{dynamicFormId}} - {{form.name}}</span>
      <el-button size="mini" icon="el-icon-upload" class="dfcd-save" @click="toSave" type="primary">保 存</el-button>
      <el-button size="mini" icon="el-icon-circle-close" class="dfcd-close" @click="show = false">退 出</el-button>
    </div>
    <design-area ref="designArea" :endpoint="endpoint" :dfTablecolumns="dfTablecolumns" :uiId="uiId" group="index-form"></design-area>

    <el-dialog title="保存表单" :visible.sync="showForm" append-to-body>
      <el-form :model="form" :rules="formRule" ref="form" :status-icon="true" label-position="top">
        <el-form-item label="表单名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入表单名称"></el-input>
        </el-form-item>
        <el-form-item label="访问控制类型" prop="acType">
          <el-radio-group v-model="form.acType">
            <el-radio-button :label="acType.key" v-for="acType in acTypes" :key="acType.key">{{acType.label}}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="描述" prop="desc">
          <el-input v-model="form.desc" placeholder="请填写表单描述" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="mini" @click="showForm = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="doSave(false)">保 存</el-button>
        <el-button size="mini" type="primary" @click="doSave(true)">保存并退出</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { acTypes } from '@/config'
import { throwError } from '@/util'
import { getApiType } from './util'
import DesignArea from './DesignArea'

export default {
  name: 'form-config-dialog',
  components: {
    DesignArea
  },
  props: {
    uiId: { type: Number, required: true },
    endpoint: { type: String, required: true },
    dfTablecolumns: { type: Array, required: false}
  },
  data () {
    return {
      acTypes: acTypes,
      show: false,
      dynamicFormId: null,
      showForm: false,
      form: { name: '', acType: '', desc: '', tableName: '', idColumnName: '', accountColumnName: '', createTimeColumnName: '', updateTimeColumnName: '', creatorColumnName: '', updatorColumnName: '' },
      formRule: {
        name: [{ required: true, message: '请输入表单名称', trigger: 'blur' }],
        acType: [{ required: true, message: '请选择访问控制类型', trigger: 'change' }]
      }
    }
  },
  methods: {
    open (dynamicForm, dynamicFormIdOfClone) {
      this.dynamicFormId = dynamicForm.dynamicFormId
      this.form = { name: dynamicForm.name, acType: dynamicForm.acType, desc: dynamicForm.desc, tableName: dynamicForm.tableName, idColumnName: dynamicForm.idColumnName, accountColumnName: dynamicForm.accountColumnName, createTimeColumnName: dynamicForm.createTimeColumnName, updateTimeColumnName: dynamicForm.updateTimeColumnName, creatorColumnName: dynamicForm.creatorColumnName, updatorColumnName: dynamicForm.updatorColumnName }
      this.show = true

      this.$nextTick(() => {
        let dynamicFormId = this.dynamicFormId || dynamicFormIdOfClone
        if (dynamicFormId) {
          this.$http.request({
            method: 'get',
            url: `/api/cgDynamicForms/${dynamicFormId}/config`
          }).then((res) => {
            this.$refs.designArea.init(res.data.data)
          })
        } else {
          this.$refs.designArea.init()
        }
      })
    },
    toSave () {
      if (!this.$refs.designArea.hasConfig()) {
        this.$message.error('请先完成配置')
        return
      }
      this.showForm = true
    },
    doSave (exit) {
      let config = this.$refs.designArea.getConfig(true)
      if (!config) {
        this.$message.error('请先完成配置')
        return
      }

      let autoCreateTable = this.form.tableName === 'df_'
      let columns = this.getColumns(config, autoCreateTable)
      if (!columns.length) {
        this.$message.error('请配置表单元素')
        return
      }
      if (!autoCreateTable) {
        columns = []
      }

      this.$refs.form.validate((success) => {
        if (!success) {
          return false
        }

        let data = {
          uiId: this.uiId,
          name: this.form.name,
          acType: this.form.acType,
          config: JSON.stringify(config),
          createTimeColumnName: this.form.createTimeColumnName,
          updateTimeColumnName: this.form.updateTimeColumnName,
          creatorColumnName: this.form.creatorColumnName,
          updatorColumnName: this.form.updatorColumnName,
        }
        if (this.form.desc) {
          data.desc = this.form.desc
        }
        if (this.form.tableName) {
          data.tableName = this.form.tableName
        }
        if (this.form.idColumnName) {
          data.idColumnName = this.form.idColumnName
        }
        if (this.form.accountColumnName) {
          data.accountColumnName = this.form.accountColumnName
        }
        if (columns.length) {
          data.columns = columns
        }

        let dynamicFormId = this.dynamicFormId
        this.$http.request({
          method: !dynamicFormId ? 'post' : 'put',
          url: !dynamicFormId ? '/api/cgDynamicForms' : `/api/cgDynamicForms/${dynamicFormId}`,
          data: JSON.stringify(data)
        }).then(() => {
          this.$message.success('保存成功')
          this.showForm = false
          if (exit) {
            this.show = false
          }
          this.$emit('save')
        })
      })
    },
    getColumns (configs, autoCreateTable, columnNameMap) {
      columnNameMap = columnNameMap || {}

      let columns = []
      for (let config of configs) {
        let apiType = getApiType(this.endpoint, 'index-form', config)
        if (apiType === 'container') {
          columns = columns.concat(this.getColumns(config.children || [], autoCreateTable, columnNameMap))
          continue
        }
        if (apiType !== 'form-control') {
          continue
        }

        let properties = config.properties || []
        let columnName = this.findPropertyValue(properties, 'name', null)
        if (!columnName) {
          throwError(`系统错误：表单元素组件${config.name}没有表单元素名称属性`)
        }
        if (columnNameMap[columnName]) {
          throwError(`表单元素命名冲突：${columnName}`)
        }
        columnNameMap[columnName] = true

        let advancedProperties = config.advancedProperties || []
        if (autoCreateTable) {
          let notGenerateColumn
          for (let advancedProperty of advancedProperties) {
            if (advancedProperty.name === 'generateColumn' && advancedProperty.value === false) {
              notGenerateColumn = true
              break
            }
          }
          if (notGenerateColumn) {
            delete config.valueType
            continue
          }
        }

        let valueType = null
        let min = null
        let max = null
        let precision = null
        let columnType = this.findPropertyValue(advancedProperties || [], 'columnType', null)
        if (!columnType) {
          valueType = config.valueType
          if (!valueType) {
            throwError(`系统错误：表单元素组件${config.name}没有value属性`)
          }

          if (valueType === 'number') {
            min = this.findPropertyValue(properties, 'min', '0')
            max = this.findPropertyValue(properties, 'max', '2147483647')
            if (min > max) {
              throwError(`表单元素${columnName}的最小值${min}大于最大值${max}`)
            }

            precision = this.findPropertyValue(properties, 'precision', 0)
            if (precision < 0) {
              throwError(`表单元素${columnName}小数点后的数字个数为${precision}，小于0，系统无法支持`)
            }
            if (precision > 30) {
              throwError(`表单元素${columnName}小数点后的数字个数为${precision}，超过了30，系统无法支持`)
            }
          }
        }
        delete config.valueType

        columns.push({
          name: columnName,
          type: columnType,
          nullable: this.findPropertyValue(properties, 'required', false) ? 'NO' : 'YES',
          desc: this.findPropertyValue(properties, 'label', ''),
          valueType: valueType,
          min: min,
          max: max,
          precision: precision,
          minlength: valueType === 'string' ? this.findPropertyValue(properties, 'minlength', 0) : null,
          maxlength: valueType === 'string' ? this.findPropertyValue(properties, 'maxlength', 200) : null
        })
      }
      return columns
    },
    findPropertyValue (properties, name, defaultValue) {
      let property = properties.find(p => p.name === name)
      let value = property ? property.value : null
      if (value === undefined || value === null) {
        return defaultValue
      }
      return value
    }
  }
}
</script>

<style lang='less'>
.dfcd{
  .el-dialog__header{
    padding:15px 0;
    border-bottom:1px solid #ebeef5;
    >div{position:relative;text-align:center;height:28px;line-height:28px;}
  }
  .el-dialog__body{padding:0;}
}
.dfcd-save{position:absolute;top:0;right:96px;line-height:26px;padding:0 15px;}
.dfcd-close{position:absolute;top:0;right:10px;line-height:26px;padding:0 15px;}
</style>
